<template lang="pug">
.section
  .section-header
    template(v-if="this.accountType == 2")
      h1 {{ $t("ui.site_customization") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
          i.fas.fa-arrow-left
      h1 {{ $t("ui.site_customization") }}
      .section-header-breadcrumb
        .breadcrumb-item.active
          router-link(to="/site/sitelist") {{ $tc("ui.site_list") }}
        .breadcrumb-item
          router-link(to="/site/siteinfo") {{ $t('ui.site_customization') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-body
            .row
              .col-12.mb-2
                .section-title.m-1 {{ operatorId }}
              .col.d-flex.justify-content-between.mb-2
                div(v-if="siteInfo != null")
                  span {{ $t('ui.production_version') }}: {{ siteInfo.site[0].production_version }}
              .col-12
                ul#siteinfotab.nav.nav-tabs(role='tablist')
                  template(v-if="siteInfo != null")
                    li.nav-item(@click="refresh('setting')")
                      a#setting-tab.nav-link(:class="{ 'active': currentTab == 'setting' }" data-toggle='tab' href='#setting-content' role='tab' aria-controls='vip' aria-selected='false') {{ $t("ui.setting") }}
                    li.nav-item( @click="refresh('theme')")
                      a#theme-tab.nav-link(:class="{ 'active': currentTab == 'theme' }" data-toggle='tab' href='#theme-content' role='tab' aria-controls='theme' aria-selected='false') {{ $t("ui.theme") }}
                    li.nav-item(@click="refresh('menu')")
                      a#menu-tab.nav-link(:class="{ 'active': currentTab == 'menu' }" data-toggle='tab' href='#menu-content' role='tab' aria-controls='menu' aria-selected='false') {{ $t("ui.menu") }}
                  li.nav-item(@click="refresh('providerseq')" v-if="isAccessProvider")
                    a#providerseq-tab.nav-link(:class="{ 'active': currentTab == 'providerseq' }" data-toggle='tab' href='#providerseq-content' role='tab' aria-controls='menu' aria-selected='false') {{ $t("ui.game_provider_management") }}
                  li.nav-item(@click="refresh('minigameop')" v-if="isAccessMiniGameOp")
                    a#minigameop-tab.nav-link(:class="{ 'active': currentTab == 'minigameop' }" data-toggle='tab' href='#minigameop-content' role='tab' aria-controls='menu' aria-selected='false') {{ $t("ui.mini_game") }}

                template(v-if="siteInfo != null")
                  #siteinfotabcontent.siteinfotabcontent.tab-content.tab-bordered(v-if="isEditAccess")
                    template(v-if="currentTab == 'setting'")
                      #setting-content.tab-pane.fade(:class="{ 'active show': currentTab == 'setting' }" role='tabpanel' aria-labelledby='setting-tab')
                        .row
                          .col-12
                            updatesetting(:siteId="siteId" :siteInfo="siteInfo" @clicked="getInfo" @callSync="submit()")
                    template(v-else-if="currentTab == 'theme'")
                      #theme-content.tab-pane.fade(:class="{ 'active show': currentTab == 'theme' }" role='tabpanel' aria-labelledby='theme-tab')
                        updatetheme(:siteId="siteId" :siteInfo="siteInfo.site[0]" @clicked="getInfo" @callSync="submit()")
                    template(v-else-if="currentTab == 'menu'")
                      #menu-content.tab-pane.fade(:class="{ 'active show': currentTab == 'menu' }" role='tabpanel' aria-labelledby='menu-tab')
                        updatemenu(:siteId="siteId" :siteInfo="siteInfo.theme_content" @clicked="getInfo" @callSync="submit()")

                  #siteinfotabcontent.siteinfotabcontent.tab-content.tab-bordered(v-else)
                    template(v-if="siteInfo != null")
                      template(v-if="currentTab == 'setting'")
                        #setting-content.tab-pane.fade(:class="{ 'active show': currentTab == 'setting' }" role='tabpanel' aria-labelledby='setting-tab')
                          settingtab(:siteDetails="siteInfo")
                      template(v-else-if="currentTab == 'theme'")
                        #theme-content.tab-pane.fade(:class="{ 'active show': currentTab == 'theme' }" role='tabpanel' aria-labelledby='theme-tab')
                          themetab(:siteDetails="siteInfo")
                      template(v-else-if="currentTab == 'menu'")
                        #menu-content.tab-pane.fade(:class="{ 'active show': currentTab == 'menu' }" role='tabpanel' aria-labelledby='menu-tab')
                          menutab(:siteDetails="siteInfo.theme_content")
                template(v-if="currentTab == 'providerseq' && isAccessProvider")
                  #providerseq-content.tab-pane.fade(:class="{ 'active show': currentTab == 'providerseq' }" role='tabpanel' aria-labelledby='providerseq-tab')
                    providerTab(:siteId="siteId" @clicked="getInfo")
                template(v-else-if="currentTab == 'minigameop' && isAccessMiniGameOp")
                  #minigameop-content.tab-pane.fade(:class="{ 'active show': currentTab == 'minigameop' }" role='tabpanel' aria-labelledby='minigameop-tab')
                    miniGameOpTab(:siteId="siteId" @clicked="getInfo")


</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
// import packageview from "@/components/siteeditor/packageView.vue";
import updatesetting from "@/components/siteeditor/updateSetting.vue";
import updatetheme from "@/components/siteeditor/updateTheme.vue";
import updatemenu from "@/components/siteeditor/updateMenu.vue";
import settingtab from '@/components/siteDetailsTab/settingTab.vue'
import themetab from '@/components/siteDetailsTab/themeTab.vue'
import menutab from '@/components/siteDetailsTab/menuTab.vue'
import providerTab from "@/components/siteeditor/providerTab.vue";
import miniGameOpTab from "@/components/siteeditor/miniGameOpTab.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    // packageview,
    updatesetting,
    updatetheme,
    updatemenu,
    settingtab,
    themetab,
    menutab,
    providerTab,
    miniGameOpTab
  },
  data: () => ({
    loading: false,
    currentTab: "setting",
    siteList: [],
    siteId: null,
    siteInfo: null,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentUrlGetInfo: null,
    operatorId: null
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isOperator() {
      return this.$store.getters.accountType === 2;
    },
    selectedSiteID() {
      return this.$store.getters.selectedSiteID;
    },
    selectedOperatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_siteinfo");
    },
    isAccessProvider() {
      return this.$helpers.showActionButton("provideroperator");
    },
    isAccessMiniGameOp() {
      return this.$helpers.showActionButton("minigameop");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    if(this.isOperator) {
      this.$store.dispatch("user/setSelectedOperatorID", this.$store.getters.accountId);
      this.operatorId = this.$store.getters.accountId

      if (this.$route.query.targetTab && ['setting','menu','theme','providerseq'].includes(this.$route.query.targetTab)) {
        if (this.$route.query.targetTab == 'providerseq' && this.isAccessProvider) {
          this.currentUrlGetInfo = config.siteInfoOperatorUrl();
          this.refresh(this.$route.query.targetTab);
        }
        else {
          if(this.showActionButton('siteinfo')) {
            this.currentUrlGetInfo = config.siteInfoOperatorUrl();
            this.getInfo();
          }
        }
      }
      //original logic
      else {
        if(this.showActionButton('siteinfo')) {
          this.currentUrlGetInfo = config.siteInfoOperatorUrl();
          this.getInfo();
        } else if(this.isAccessProvider) {
          this.refresh('providerseq')
        } else if(this.isAccessMiniGameOp) {
          this.refresh('minigameop')
        }
      }
    } else {
      this.currentUrlGetInfo = config.getSiteInfoUrl();
      this.siteId = this.selectedSiteID
      this.operatorId = this.selectedOperatorID
      if(this.showActionButton('siteinfo')) {
        this.getInfo();
      } else if(this.isAccessProvider) {
        this.refresh('providerseq')
      } else if(this.isAccessMiniGameOp) {
        this.refresh('minigameop')
      }
    }
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    redirect() {
      this.$router.push("/site/sitelist");
    },
    refresh: function(tab) {
      if(this.showActionButton('siteinfo')) {
        this.getInfo();
      }
      this.currentTab = tab;
    },
    submit() {
      this.$swal({
        title: this.$t("ui.site_sync"),
        text: this.$t("message.site_sync_confirm"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.callSiteSync();
        }
      });
    },
    callSiteSync() {
      let url = config.siteSyncUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.operatorId,
        site_id: this.siteId,
        operator_id: this.operatorId
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getInfo();
                this.$helpers.showDialog(this.$t("ui.site_sync"), this.$t("message.success"), "success");
              } else {
                this.$helpers.showDialog(this.$t("ui.site_sync"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    changeTab(item) {
      if(this.currentTab != item) this.currentTab = item;
    },
    getInfo() {
      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.operatorId,
        site_id: this.siteId
      };
      this.loading = true;

      this.$http.post(this.currentUrlGetInfo, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.siteInfo = response.data.ds;
                if(this.siteId == null && this.siteInfo != null) {
                  if(this.siteInfo.site[0].site_id != null) this.siteId = this.siteInfo.site[0].site_id
                  if(this.siteInfo.language[0].operator_id != null) this.operatorId = this.siteInfo.language[0].operator_id
                }
                if(this.siteInfo.site[0].logo != null) {
                  this.siteInfo.site[0].logo_full_path = config.viewImageUrl + this.siteInfo.site[0].logo
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>